// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"bd7dadaf","20":"3c5db668","25":"e5f04481","35":"d69230a8","46":"e05197f5","102":"18abc359","241":"e9437638","488":"730fcbd5","633":"03a04a18","854":"9410076b","926":"b22b4662"}[chunkId] + ".chunk.js";
};